module.exports = __webpack_public_path__ + "static/awasul_screens_stack-eab2e972184c3fed12baac772fa5b9c8.png";